import React, { ButtonHTMLAttributes, MouseEvent } from 'react';
import classNames from 'classnames';
import { switch_base_css, getStyleByProps } from './styles';

export type SwitchSize = 'small' | 'medium' | 'large';

export interface SwitchProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  /** @default true */
  checked?: boolean;
  /** @default 'small' */
  size?: SwitchSize;
  width?: number;
  /** @default 'ON' */
  onText?: string;
  /** @default 'OFF' */
  offText?: string;
  onChange?: (checked: boolean) => void;
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  (
    { checked = true, size = 'small', onText = 'ON', offText = 'OFF', width, className, onClick, onChange, ...props },
    ref,
  ) => {
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
      onClick?.(event);
      if (!event.defaultPrevented) {
        onChange?.(!checked);
      }
    };

    return (
      <button
        type='button'
        className={classNames('pds-switch', className)}
        css={[
          switch_base_css,
          getStyleByProps({ size, checked, width, hasLabel: Boolean(onText) && Boolean(offText) }),
        ]}
        ref={ref}
        role='switch'
        aria-checked={checked}
        onClick={handleClick}
        {...props}
      >
        <span aria-hidden>{checked ? onText : offText}</span>
      </button>
    );
  },
);
